import { PersonDataService } from "../../core/persons.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";
import { PersonsComponent } from "./persons.component";
import { EditPersonDetailsComponent } from "./details/person.edit.component";
import { PersonOverviewComponent } from "./person-overview.component";

/**
 * This state displays all Persons
 */
export const personsState: Ng2StateDeclaration = {
    name: "app.resources.persons",
    url: "/persons",
    views: {
        "main-view@app": {
            component: PersonsComponent
        }
    },
    resolve: {
        persons: [PersonDataService.Id, (personsService: PersonDataService) => {
            return personsService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Person
 */
export const newPersonState: Ng2StateDeclaration = {
    name: "app.resources.persons.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditPersonDetailsComponent
        }
    },
    resolve: {
        person: function () {
            return <Nema.Crew.Model.Person>{
                Active: true
            };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Person
 */
export const editPersonState: Ng2StateDeclaration = {
    name: "app.resources.persons.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditPersonDetailsComponent
        }
    },
    resolve: {
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Person Details state
 */
export const personState: Ng2StateDeclaration = {
    name: "app.resources.persons.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: PersonOverviewComponent
        }
    },
    resolve: {
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/persons.states.ts